var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
  'easyscreen-btj-header',
  `easyscreen-btj-header_${ _vm.size }`
]},[_c('div',{staticClass:"easyscreen-btj-header--logo"}),_c('p',{staticClass:"easyscreen-btj-header--tagline"},[_vm._v("Smarta vägar till nya upplevelser av media")])])
}
var staticRenderFns = []

export { render, staticRenderFns }